<div class="d-inline-flex">
  <ncp-button
    #addSocialHistoryButton
    [options]="btnSHOptions()"
  >
    @if(shLoading) {
      <div class="loading spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    } @else {
      <img
        [ngSrc]="assets.healthIcons.svg.outline.symbols.smoking.src"
        width="18"
        height="18"
        alt="Add Social History"
        class="healthIcon"
      />
    }
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="social_history_form"
      name="social_history_form"
      [formGroup]="form"
      #shFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #socialHistoryDesc [(options)]="socialHistoryDescDDOptions" />
<!--      <ncp-input #startYear [(options)]="startYearOptions()" />-->
<!--      <ncp-input #endYear [(options)]="endYearOptions()" />-->
      <ncp-date #startDate [(options)]="startDateOptions" />
      <ncp-date #endDate [(options)]="endDateOptions" />
    </form>
  </ncp-modal>
</div>
